<template>
    <h3 class="my-5 ml-6">Timesheet Exception Board</h3>
    <v-row class="mx-4 ">
        <v-col cols="12" md="3" xs="12" class="pb-0" >
            <label>WorkSpace</label>
            <AutoComplete 
                :items="workSpaceData" 
                item-value="id" 
                item-title="name"
                density="compact"
                placeholder="WorkSpace"  
                v-model="workSpace" 
                @update:modelValue="onWorkspaceUsers"
                :disabled="showReadOnly" 
                />
        </v-col>
        <v-col cols="12" md="3" xs="12" class="pb-0" >
            <label>User Name</label>
            <AutoComplete 
                :items="userData" 
                item-value="id" 
                item-title="name"
                density="compact"
                v-model="userName" 
                @update:modelValue="onUsersTableData"
                placeholder="User Name"  
                :disabled="showReadOnly" 
                />
        </v-col>
    </v-row>

    <v-row class="ml-4 mr-4">
        <v-col>
            <v-table height="600px" class="exception"  fixed-header>
            <thead>
                <tr>
                    <th class="text-left font-weight-bold table-header">User Name</th>
                    <th class="text-left font-weight-bold table-header entry">Entry Date (EST)</th>
                    <!-- <th class="text-left font-weight-bold table-header">shift</th>
                    <th class="text-left font-weight-bold table-header">designation</th>
                    <th class="text-left font-weight-bold table-header">login Time</th> -->
                    <th class="text-left font-weight-bold table-header">Break Hours</th>
                    <th class="text-left font-weight-bold table-header">In Between Hours</th>
                    <th class="text-left font-weight-bold table-header">Production Hours</th>
                    <!-- <th class="text-left font-weight-bold table-header">logout</th> -->
                    <th class="text-left font-weight-bold table-header">Remarks</th>
                    <th class="text-left font-weight-bold table-header">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in tableData" :key="index">  
                    <td class="table-data">{{ item.users.name }}</td>
                    <td class="table-data">{{ formatDateEst(item.entry_date) }}</td>
                    <!-- <td class="table-data">{{ item.shift }}</td>
                    <td class="table-data">{{ item.designation }}</td> -->
                    <!-- <td class="table-data">{{ item.login }}</td> -->
                    <td :class="(item.break / 60) > 1 ? 'table-over' : 'table-data'">{{ item.break && item.break ? ( item.break  / 60 ).toFixed(2): 0 }}</td>
                    <td :class="(item.in_between / 60) > 0.50 ? 'table-over' : 'table-data'">{{ item.in_between && item.in_between ? ( item.in_between  / 60 ).toFixed(2): 0 }}</td>
                    <td :class="(item.production / 60) < 8 ? 'table-over' : 'table-data'">{{ item.production && item.production ? ( item.production  / 60 ).toFixed(2): 0 }}</td>
                    <!-- <td class="table-data">{{ item.logout }}</td> -->
                    <!-- <td class="table-data  pa-2">
                      <textarea class="text-area" name="remarks" rows="3" id="rem"></textarea>
                    </td> -->
                    <td class="table-data pa-2">
                      <textarea
                        :key="item.id"
                        v-model="item.remarks"
                        @change="saveRemarks(item)"
                        rows="3"
                        class="text-area"
                        :class="{ 'is-invalid':item.remarksError }"
                      ></textarea>            
                      <div v-if="item.remarksError" :class="{'error-msg':item.remarksError}">Remarks field is required.</div>
                    </td>
                    <td class="table-data txt-area py-2 d-flex align-center justify-center ga-5">
                      <v-icon
                        size="medium"
                        @click="showTimeSheet(item)"
                      >
                        mdi-eye
                      </v-icon>

                        <v-btn @click="validateForm(item)">
                          submit
                        </v-btn>
                    </td>

                </tr>
                <tr v-if="tableData.length === 0">
                <td colspan="8">
                    <p class="no-data-container">Timesheet Exception Board data not available</p>
                </td>
                </tr>
            </tbody>
            </v-table>
            <v-dialog v-model="timeSheet" min-width="1000">
              <div class="d-flex justify-end mb-2">
                <v-btn icon class="d-flex  align-center cross-btn">
                  <v-icon size="16" @click="timeSheet=false">mdi-close</v-icon>
                </v-btn>
              </div>
                <v-table class="time-table">
                  <thead>
                    <tr>
                      <th class="noWrap">Account</th>
                      <th class="noWrap">Project</th>
                      <th class="noWrap">Sub Category/Task</th>
                      <th class="noWrap">Actual Hours</th>
                      <th class="noWrap">Paid Hours</th>
                      <th v-if="showEdit"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(entry, index) in timeSheetData" :key="index">
                      <td class="noWrap">{{ entry.account_name }}</td>
                      <td class="noWrap">{{ entry.project_name }}</td>
                      <td class="noWrap">{{ entry.issue_id ? entry.category_name : entry.task_name}}</td>
                      <td class="noWrap">{{ entry && entry.actual_hrs ?( entry.actual_hrs  / 60 ).toFixed(2): ''}}</td>
                      <td class="noWrap">{{ entry && entry.billed_hrs ?( entry.billed_hrs  / 60 ).toFixed(2): ''}}</td>
                      <td v-if="showEdit">
                        <v-btn flat v-if="entry.task_type!='inbetweentime'"  icon="mdi-pencil" size="x-small"  class="edit-btn" @click="$emit('editEntry', entry.id)">
                        </v-btn>
                      </td>
                    </tr>
                    <tr v-if="timeSheetData.length === 0">
                      <td colspan="8">
                          <p class="no-data-container">Timesheet data not available</p>
                      </td>
                      </tr>
                  </tbody>
                  
                </v-table>
            </v-dialog>
        </v-col>
  </v-row>

</template>

<script>
import AutoComplete from "@/components/ui/AutoComplete.vue";
import moment from "moment";
import dayjs from 'dayjs';
import 'vuetify/styles'
import WorkSpaceService from "@/api/service/WorkSpace/WorkSpaceService";
import TimeSheetExceptionService from "@/api/service/TimeSheetException/TimeSheetExceptionService";
import TimeSheetService from "@/api/service/TimeSheet/TimeSheetService";


export default {
  components: {
    AutoComplete,
  },
  data() {
    return {
      workSpaceId:'',
      workSpace: [], 
      tableData: [], 
      timeSheet:false,
      userName:[],
      workSpaceData:[],
      userData:[],
      timeSheetData:[],
      entryDate:new Date(),
    };
  },
  methods:{
    async saveRemarks (data){
      data.remarksError = false
      let remarks ={
          id: data.id,
          remarks: data.remarks
            ? data.remarks
            : null,
        };

      await TimeSheetExceptionService.update(remarks)
    },

    async validateForm(item) {
      item.remarksError = !item.remarks || item.remarks.trim() === '';
      
      if (!item.remarksError) {
        await TimeSheetExceptionService.update({id:item.id,stage:'completed'})
        this.onUsersTableData(item.user_id)
      }
    },

    async onWorkspaceUsers(workspace_id){
      let role_id = localStorage.getItem('user_details')
      role_id = JSON.parse(role_id).roles.role_type
      await TimeSheetExceptionService.timeSheetExceptionUsers({id:workspace_id,role_type_id:role_id}).then((response)=>{
        this.userData = response && response.length > 0? response:[]
      }).catch(e=>{
        console.log(e)
      })
    },
    
    async getWorkSpaceData(){
      await WorkSpaceService.getWorkSpaceByUser({active:1}).then((response)=>{
        this.workSpaceData = response && response.length > 0? response:[]
      }).catch(e=>{
        console.log(e)
      })
    },   

    async onUsersTableData(user_id){
      await TimeSheetExceptionService.findAll({user_id:user_id,stage:'pending'}).then((response)=>{
        response.forEach(e => {
          e.remarksError = false
        });
        this.tableData = response && response.length > 0? response:[]
      }).catch(e=>{
        console.log(e)
      })
    },

    formatDateEst(date) {
      return dayjs(date.split('T')[0]).format('MMM D, YYYY')
    },

    async showTimeSheet(data){
      this.timeSheet = true
      this.entryDate = moment(data.entry_date).format("YYYY-MM-DD")
      console.log(this.entryDate,'data@@@')
      console.log(data.user_id,'user_id @@@')
      console.log(data.entry_date,'entry_date @@@')
      await TimeSheetService.getTSData({user_id:data.user_id,date:this.entryDate}).then((response)=>{
        this.timeSheetData = response && response.length > 0 ? response : [] 
      }).catch (e =>{
        console.log("Error:", e);
      })

    }
  },

  created(){
    this.getWorkSpaceData()   
  }
}
</script>

<style scoped>
    .is-invalid {
      border: 1px solid red;
    }
    .error-msg {
      color: red;
      font-size: 12px;
    }
    .txt-area{
      height: 107px !important;
    }
    .exception{
      border-radius: 5px;
    }
    .cross-btn{
      width: 30px;
      height: 30px;
    }
    .sheet-header{
      text-align: center !important;
    }
    .table-header {
        background-color: #1e6ca3 !important; 
        color: #fff; 
        font-weight: bold;
        text-align: center !important;
    }
    .table-data {
        background-color: #ffffff !important; 
        color: #000; 
        font-weight: bold;
        text-align: center;
    }
    .table-over{
        background-color: #fff !important; 
        color: #ffb600; 
        font-weight: bold;
        text-align: center;
    }
    .text-area{
        background-color: #d0e1fd !important;
    }
    .no-data-container{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 500px;
    }
    .time-table {
      border-radius: 5px;
      width: 100%;
      border-collapse: separate;
      border-spacing: 0 10px;

      thead {
        border: 1px solid #cbf0fd;
        background-color: #e3f2fd;

        th {
          font-size: 0.875rem;
          font-weight: 400;
          padding: 12px;
          text-align: left;
          color: #000;
        }
      }

      tbody {
        tr {
          font-size: 0.875rem;
          font-weight: 400;
          position: relative;
          overflow: hidden;
          border: 1px solid #cbf0fd;
          border-radius: 8px;

          &:nth-child(odd) {
            background-color: #ebf1f3;
          }

          &:nth-child(even) {
            background-color: #fff;
          }

          td {
            padding: 4px;
            text-align: left;
            color: #333;
          }

          &:hover {
            background-color: #f5f5f5;
          }
        }
      }
    }

.edit-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.noWrap{
  text-wrap:nowrap;
}
</style>